// Should already be required, just here for clarity
require('angular');

// load the angular-base64 module
require('./angular-base64.js')

module.exports = 'base64';


//////////////////
// WEBPACK FOOTER
// ./~/@ninjatronic/angular-base64/index.js
// module id = 353
// module chunks = 2